<template>
  <base-modal ref="modal">
    <base-card>
      <h3 class="tw-text-xl tw-font-thin">Are you sure?</h3>
      <p class="tw-text-gray-600 tw-mt-2" v-html="message" />
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="save" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Save</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
export default {
  props: {
    userId: String,
    useGlobalCard: Boolean,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    message() {
      return !this.useGlobalCard
        ? "By turning this setting on you will update your payment method for any existing savings plans to use your Default payment method."
        : "By turning this setting off you will stop using your default payment method for all savings plans. This will not change any existing savings plan payment methods, but it will allow you to change the payment methods for each individual savings plan.";
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async save() {
      try {
        this.isLoading = true;
        await this.$axios.put(`/users/${this.userId}/globalcard/${!this.useGlobalCard}`);
        this.hide();
        this.EventBus.$emit("GLOBAL_NOTIFY", {
          title: !this.useGlobalCard ? "Global Card Activated" : "Global Card Deactivated",
          message: "Your setting has been updated",
        });
        this.$emit("update:useGlobalCard", !this.useGlobalCard);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
